import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const getToken = () => localStorage.getItem('token');

const authHeaders = () => ({
  headers: { Authorization: `Bearer ${getToken()}` }
});

// Auth
export const seedDatabase = () => axios.post(`${API_URL}/seed`);

// Assets
export const getAssets = (params = {}) => 
  axios.get(`${API_URL}/assets`, { ...authHeaders(), params });

export const getAsset = (id) => 
  axios.get(`${API_URL}/assets/${id}`, authHeaders());

export const createAsset = (data) => 
  axios.post(`${API_URL}/assets`, data, authHeaders());

export const updateAsset = (id, data) => 
  axios.put(`${API_URL}/assets/${id}`, data, authHeaders());

export const deleteAsset = (id) => 
  axios.delete(`${API_URL}/assets/${id}`, authHeaders());

export const getAssetBarcode = (id) => 
  axios.get(`${API_URL}/assets/${id}/barcode`, authHeaders());

export const getAssetHistory = (id) => 
  axios.get(`${API_URL}/assets/${id}/history`, authHeaders());

// Hire Orders
export const getHireOrders = (params = {}) => 
  axios.get(`${API_URL}/hire-orders`, { ...authHeaders(), params });

export const getHireOrder = (id) => 
  axios.get(`${API_URL}/hire-orders/${id}`, authHeaders());

export const createHireOrder = (data) => 
  axios.post(`${API_URL}/hire-orders`, data, authHeaders());

export const updateHireOrder = (id, data) => 
  axios.put(`${API_URL}/hire-orders/${id}`, data, authHeaders());

export const addItemToOrder = (orderId, assetId) => 
  axios.post(`${API_URL}/hire-orders/${orderId}/add-item?asset_id=${assetId}`, {}, authHeaders());

export const downloadDeliveryNote = (orderId) => {
  const token = getToken();
  window.open(`${API_URL}/hire-orders/${orderId}/delivery-note?token=${token}`, '_blank');
};

export const downloadCollectionNote = (orderId) => {
  const token = getToken();
  window.open(`${API_URL}/hire-orders/${orderId}/collection-note?token=${token}`, '_blank');
};

export const emailNoteToClient = (orderId, data) => 
  axios.post(`${API_URL}/hire-orders/${orderId}/email-note`, data, authHeaders());

// Damage Reports
export const getDamageReports = (params = {}) => 
  axios.get(`${API_URL}/damage-reports`, { ...authHeaders(), params });

export const createDamageReport = (data) => 
  axios.post(`${API_URL}/damage-reports`, data, authHeaders());

// Notifications
export const getNotifications = (unreadOnly = false) => 
  axios.get(`${API_URL}/notifications`, { ...authHeaders(), params: { unread_only: unreadOnly } });

export const markNotificationRead = (id) => 
  axios.put(`${API_URL}/notifications/${id}/read`, {}, authHeaders());

export const markAllNotificationsRead = () => 
  axios.put(`${API_URL}/notifications/read-all`, {}, authHeaders());

// Mobile Actions
export const scanBarcode = (barcode) => 
  axios.get(`${API_URL}/actions/scan/${barcode}`, authHeaders());

export const confirmDelivery = (data) => 
  axios.post(`${API_URL}/actions/delivery`, data, authHeaders());

export const confirmCollection = (data) => 
  axios.post(`${API_URL}/actions/collection`, data, authHeaders());

// Dashboard
export const getDashboardStats = () => 
  axios.get(`${API_URL}/dashboard/stats`, authHeaders());

export const getUtilizationStats = () => 
  axios.get(`${API_URL}/dashboard/utilization`, authHeaders());

export const getHireActivity = () => 
  axios.get(`${API_URL}/dashboard/hire-activity`, authHeaders());

export const getRecentAlerts = () => 
  axios.get(`${API_URL}/dashboard/alerts`, authHeaders());

// Tasks
export const getTodayTasks = () => 
  axios.get(`${API_URL}/tasks/today`, authHeaders());

// User Management (Admin only)
export const getUsers = () => 
  axios.get(`${API_URL}/users`, authHeaders());

export const createUser = (data) => 
  axios.post(`${API_URL}/users`, data, authHeaders());

export const updateUser = (id, data) => 
  axios.put(`${API_URL}/users/${id}`, data, authHeaders());

export const deleteUser = (id) => 
  axios.delete(`${API_URL}/users/${id}`, authHeaders());

// Hire Order Delete
export const deleteHireOrder = (id) => 
  axios.delete(`${API_URL}/hire-orders/${id}`, authHeaders());

// Reports Download
export const downloadReportPDF = () => {
  const token = getToken();
  window.open(`${API_URL}/reports/assets/pdf?token=${token}`, '_blank');
};

export const downloadReportExcel = () => {
  const token = getToken();
  window.open(`${API_URL}/reports/assets/excel?token=${token}`, '_blank');
};
